export const areasData = {
    Dubai: [
      "Dubai Marina", "Palm Jumeirah", "Bluewaters Island",
      "Springs", "Business Bay", "Jumeirah Islands",
      "Mirdiff", "Al Barari", "Al Khawaneej",
      "Arabian Ranches", "DIP", "Discovery Gardens",
      "Golden Mile", "JVT", "Jaddaf",
      "Mushrif", "Sufouh", "Dubai Creek Harbour",
  
      "Jumeirah", "Emirates Hills", "Dubai Hills",
      "Meadows", "DIFC", "Umm Suqeim",
      "Media City", "Sports City", "Al Mizhar",
      "Barsha", "Dubai Land", "Greens",
      "JVC", "Jumeirah Park", "MBR City",
      "Remraam", "Tecom", "Port De La Mer",
  
      "Downtown Dubai", "Meydan", "Damac Hills",
      "Damac Hills 2", "City Walk", "JBR",
      "The Villa", "District One", "Al Furjan",
      "Al Safa", "Bur Dubai", "Deira",
      "Dubai South", "JLT", "Karama",
      "Motor City", "Silicon Oasis", "Wasl",
      "Expo City"
    ],
  
    "Abu Dhabi": [
      "Abu Dhabi City",
      "Khalifa City",
      "Reem Island",
      "Saadiyat"
    ]
  };
  